/**
 * Join CSS Module class names, dropping anything falsy.
 *
 * Both apps are CSS Modules since #443, and a module's exported names are
 * opaque hashes — so the one thing every call site needs is to compose a few
 * of them conditionally. That is all this does: no merge semantics, no
 * last-wins resolution, no arbitrary-value parsing. Two modules that set the
 * same property still resolve by CSS source order, exactly as two hand-written
 * classes always have, which is why a variant class never also accepts a
 * colour from its caller (DESIGN-SYSTEM.md, Selects).
 */
export function cx(
  ...parts: (string | false | null | undefined)[]
): string {
  return parts.filter(Boolean).join(" ");
}
